import { basenames, appBaseName } from 'config/basenames';

export const BUILD_ID = process.env.REACT_APP_BUILD_ID || '';
export const IFRAME_MODE_MIN_HEIGHT = 400;
export const NEW_IFRAME_MODE_MIN_HEIGHT = 600;
export const APP_RUNNING_ENV = process.env.REACT_APP_RUNNING_ENV || 'prod';
export const IS_LOCAL_DEV = process.env.NODE_ENV === 'development';
export const IS_LIVE_PROD = APP_RUNNING_ENV === 'prod' && !IS_LOCAL_DEV;
export const IS_DEV = APP_RUNNING_ENV === 'dev';
export const IS_IFRAME_MODE = window.self !== window.top;
export const IS_EDITOR_MODE = /\/promotions\/\d+\/\d+\/edit(?:\/)?/i.test(window.location.pathname);
export const IS_UGC_FLOW = appBaseName === basenames.ugc;
export const IS_POINT_FLOW = appBaseName === basenames.point;
export const IS_PROMO_FLOW = appBaseName === basenames.promotions;
export const GLOBAL_LIFF_ID = IS_LIVE_PROD ? '1654689974-YnaByKaZ' : '1608309930-D00eq7P7';
export const SENTRY_REACT_DSN =
    process.env.REACT_APP_SENTRY_REACT_DSN || 'https://6435505397a300484ccafa330b509f9a@o512271.ingest.sentry.io/5611931';
export const SENTRY_TRACES_SAMPLE_RATE =
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ||
    '0.00001';

export const POWER_BY_HEIGHT = 32;
export const IMG_UPLOAD_API_PATH = '/services/images';

export const FROALA_KEY =
    process.env.REACT_APP_FROALA_V2_KEY_GENERAL || 'ZF3G4I3A7aD6C4C3F2G3D2J2C9C3D5tooB-8iJ-7A-21d1sxsC-9B1vyz==';
export const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdbD7kUAAAAAHBmg7tQxM1KyJ20kRhl-cDjWlIW';
export const EDITOR_WINDOW_ORIGIN = process.env.REACT_APP_EDITOR_FEVER_HOST
    ? `https://${process.env.REACT_APP_EDITOR_FEVER_HOST}`
    : window.location.origin;
export const EDITOR_API_FEVER_HOST =
    process.env.REACT_APP_EDITOR_FEVER_HOST || window.location.host;
export const CLIENT_API_FEVER_HOST =
    process.env.REACT_APP_CLIENT_FEVER_HOST || window.location.host;
export const INTERCOM_SECRET_KEY =
    process.env.REACT_APP_INTERCOM_SECRET_KEY || 'xdsqVb3gLQtypbClG8EZFFSh4Mx_PRTcHLTQT073';
export const MOCK_API_ENDPOINT = 'http://localhost:3002';

export const {
    FEVER_API_ENDPOINT,
    ZINES_API_ENDPOINT,
    FEVER_LOGIN_API_ENDPOINT,
    SDK_ENV_SUFFIX_BY_ENV,
    IMG_PROXY_PATH,
    THIRD_PARTY_AUTH_ENDPOINT
} = (runningEnv => {
    switch (runningEnv) {
        case 'prod':
            return {
                FEVER_API_ENDPOINT: 'https://api.feversocial.com',
                ZINES_API_ENDPOINT: 'https://api.feversocial.com/zines',
                FEVER_LOGIN_API_ENDPOINT: 'https://feversocial.com',
                SDK_ENV_SUFFIX_BY_ENV: '',
                IMG_PROXY_PATH: `https://image.fevercdn.com`,
                THIRD_PARTY_AUTH_ENDPOINT: 'https://feversocial.com'
            };
        case 'dev':
        default:
            return {
                FEVER_API_ENDPOINT: 'https://api.dev.feversocial.com',
                ZINES_API_ENDPOINT: 'https://api.dev.feversocial.com/zines',
                FEVER_LOGIN_API_ENDPOINT: 'https://dev.feversocial.com',
                SDK_ENV_SUFFIX_BY_ENV: '-dev',
                IMG_PROXY_PATH: `https://image.fevercdn.com/dev`,
                THIRD_PARTY_AUTH_ENDPOINT: 'https://dev.feversocial.com'
            };
    }
})(APP_RUNNING_ENV);
